export default "__VITE_ASSET__0ea8c42c__"